import { LogDrawerFetcher } from "@components/llama/LogDrawer/LogDrawer";
import React, { createContext, useContext, useState } from "react";

interface DrawerContextProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  // TODO: make this more generic, maybe like content, setContent
  // with type Content = {type: "log", id: string} etc.
  logId: string | undefined;
  setLogId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const DrawerContext = createContext<DrawerContextProps | undefined>(undefined);

export const DrawerContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [logId, setLogId] = useState<string | undefined>(undefined);

  return (
    <>
      <DrawerContext.Provider value={{ open, setOpen, logId, setLogId }}>
        {children}
        {/* TODO: the currentPage thing is obviously dumb but this is only used there atm,
         and I don't want to spend the time now getting the page robustly */}
        <LogDrawerFetcher logId={logId} open={open} setOpen={setOpen} currentPage={"editor"} />
      </DrawerContext.Provider>
    </>
  );
};

/** A context hook to render the drawer to show Logs, etc.
 *
 * Initially I'm just designing this to be used in Prompt Editor, so have just done
 * the simplest dumbest thing possible. However, I think this could be made
 * more generic and reusable.
 *
 * Ideas:
 * - use this for everywhere we use the drawers
 * - load any content
 * - keep a stack of drawers, and manage them
 */
export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (context === undefined) {
    throw new Error("useDrawer must be used within a DrawerContextProvider");
  }
  return context;
};
